import React, { useState, useCallback, useImperativeHandle } from 'react';
import { Button, Input, Drawer, message } from 'antd'; 
import { usePatchTagMutation } from '../../gql/hooks/usePatchTagMutation';  
import { useDeleteTagMutation } from '../../gql/hooks/useDeleteTagMutation';  
import { Loadable } from '../../../components/loadable/Loadable'; 
import DeleteButton from '../../../components/DeleteButton'; 
import './styles.less';

const TagEdit = ( { editedTagCallback, deleteTagCallback, ref } ) => {
    const [ tag, setTag ] = useState();
    const [ tagName, setTagName ] = useState( '' );
    const [ isLoading, setIsLoading ] = useState( '' );
    const [ isDrawerVisible, setIsDrawerVisible ] = useState( false );

    const [ editTag ] = usePatchTagMutation();
    const [ deleteTag ] = useDeleteTagMutation();

    useImperativeHandle( ref, () => ( {
        showDrawer( tag ) {
            setTag( tag );
            setTagName( tag.name );
            setIsDrawerVisible( true );
        }
    } ) );

    /*************************
     * Save the Tag 
     ************************/ 

    const saveTag = async () => {
        try {
            const response = await editTag( { variables: { input: { name: tagName, id: tag.id } } } );
            const success = !( response?.error || response?.errors && response?.errors?.length > 0 );
            
            if ( success ) {
                setIsLoading( false );
                setIsDrawerVisible( false );
                deleteTagCallback();
                editedTagCallback();
            } else {
                setIsLoading( false );
                setIsDrawerVisible( false );
                console.error( response ); 
                message.error( 'Error creating tag!' ); 
            }
        } catch ( e ) { 
            setIsLoading( false );
            setIsDrawerVisible( false );
            console.error( e ); 
            message.error( 'Error creating tag!' );
        }
    };

    /*************************
     * Event handling  
     ************************/ 
    
    const handleInputChange = ( e ) => { 
        setTagName( e.currentTarget.value );
    };

    const handleSaveClick = () => {
        setIsLoading( true );
        saveTag();
    };

    const handleCloseClick = () => { 
        setIsDrawerVisible( false );
    };

    const handleDeleteTagClick = useCallback( async () => {
        if ( !tag?.id ) {
            return null;
        }

        setIsLoading( true );

        try {
            await deleteTag( { variables: { input: { id: tag.id } } } );
        } catch ( e ) { 
            console.error( e ); 
            message.error( 'Error deleting tag!' );
        }

        if ( editedTagCallback ) {
            editedTagCallback();
        }
        setIsDrawerVisible( false );
        setIsLoading( false );
        deleteTagCallback();
    }, [ deleteTag, editedTagCallback, tag ] );

    /*************************
     * Render  
     ************************/ 
    
    return (
        <Drawer 
            title="Edit Tag" 
            placement="right" 
            destroyOnClose={ true }
            open={ isDrawerVisible }
            closable={ false}
        >
            <Loadable loading={ isLoading }>
                
                { /* Tag name input */ }
                <Input
                    autoFocus
                    value={ tagName }
                    placeholder="Tag name"
                    maxLength={ 128 }
                    onChange={ handleInputChange }
                /> 
            </Loadable>
            
            <div className="edit-drawer-buttons">

                { /* Cancel button */ }
                <Button
                    disabled={ isLoading }
                    onClick={ handleCloseClick }
                >
                    Cancel
                </Button>

                { /* Save button */ }
                <Button
                    type="primary"
                    htmlType="submit" 
                    disabled={ !( tagName.trim() ) || isLoading } 
                    onClick={ handleSaveClick }
                >
                    Save
                </Button>

                { /* Delete button */ }
                { !isLoading && 
                    <DeleteButton 
                        disabled={ isLoading }
                        danger
                        isLoading
                        type="link"
                        itemType="tag"
                        onDelete={ handleDeleteTagClick }
                        confirmMessage= { 
                            <React.Fragment>
                                <p>Are you <i>sure</i> you want to permanently delete this tag? 
                                All users who have progress in this item will <i>lose their progress</i>. This action cannot be undone.</p>
                            </React.Fragment>
                        }
                    >
                        Delete
                    </DeleteButton>
                }
            </div>
        </Drawer>
    );
};

export default TagEdit;
